import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { connect } from 'react-redux';
import Truncate from 'react-truncate';
import { compose, withStateHandlers } from 'recompose';

const mapStateToProps = (state) => ({})
const mapDispatchToProps = (dispatch) => ({
})

export const UnspecifiedCpdCategory = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      showTooltip: true,
      truncated: false
    },
    {
      setShowTooltip: () => (showTooltip) => ({
        showTooltip
      }),
      onTruncate: () => (truncated) => ({
        truncated
      })
    }
  )
)(({ showTooltip, setShowTooltip, truncated, onTruncate }) => {
  const tooltip = <Popover id="cpd-category-name-tooltip">
    <p className='no-margin'>The host of this event has not yet announced the CPD categories associated with the event, but has indicated CPD can be awarded for attending</p>
  </Popover>


  const clickHandler = (e) => {
    setShowTooltip(!showTooltip)
  }
  const truncatedCpdCategoryName = <Truncate onTruncate={onTruncate}>
    CPD Available
  </Truncate>

  const child = <span className={`cat clickable`} onClick={clickHandler}>{truncatedCpdCategoryName}</span>
  return <OverlayTrigger placement="top" trigger='hover' overlay={tooltip}>
    {child}
  </OverlayTrigger>
})


// WEBPACK FOOTER //
// ./src/containers/pages/app/partials/unspecified-cpd-category.js